/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { Col, Input, Form, Select, Radio, Modal, Row, Button } from "antd";
import {
  checkAlphabets,
  checkSpecialCharacter,
  checkSpace,
  capitalize,
  checkNumbervalue,
} from "../utils";
import cross_button from "../assests/images/CrossButton.svg";
import { ReactComponent as Reason } from "../assests/images/SVG/check.svg";
import PinCodeValidator from "./PincodeValidator";
import API from "../api";
import urls from "../api/urls";
const { VERIFY_GST } = urls;
import AutoCompleteAddress from "../views/FirstMile/CrediteBooking/AutoCompleteAddress";

export const CreateKYC = ({
  getData,
  form,
  orgName,
  rgColSpan,
  orgType,
  hideGst,
  hideAadhaar,
  hidePan,
  hideTan,
  disable,
  required = true,
}) => {
  //const [form] = Form.useForm();
  const [isGSTRegister, setIsGSTRegister] = useState(true);
  const [checkStatus, setCheckStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [gstPin, setGstPin] = useState(null);

  const orgFormName = orgType ? orgType : "orgName";

  useEffect(() => {
    if (getData?.kycDocuments?.length > 0) {
      const GST =
        getData?.kycDocuments?.find((doc) => doc.idType === "GST")?.idNumber ||
        null;
      setIsGSTRegister(GST ? true : false);
    }
  }, [getData]);

  function handleIsGSTRegistered(params) {
    setIsGSTRegister(params.target.value);
    setCheckStatus(false);
    form.setFieldsValue({
      street: "",
      area: "",
      pincode: "",
      GST: "",
      setGstPin: "",
      AADHAR: "",
      PAN: "",
      organizationNamee: "",
      orgFormName: "",
    });
  }

  const extractPANFromGST = (gstNumber) => {
    if (gstNumber && gstNumber.length === 15) {
      return gstNumber.substring(2, 12); // Extract characters from index 2 to 11
    }
    return "";
  };

  const checkGST = async (event) => {
    const gstNumber = event.target.value.toUpperCase();

    if (gstNumber.length <= 14) {
      setCheckStatus(false);
      return;
    }

    try {
      const response = await API.Api(VERIFY_GST + gstNumber).get();
      const data = response?.response?.data?.result?.gstnDetailed || {};
      const gst = response?.response?.data?.essentials?.gstin || "";

      if (response.status && data?.gstinStatus?.toUpperCase() === "ACTIVE") {
        setCheckStatus(true);
        setGstPin(data?.principalPlacePincode);

        const clientName = form.getFieldValue(orgFormName);
        form.setFieldsValue({
          organizationNamee: data?.tradeNameOfBusiness,
          street: data?.principalPlaceAddress,
          area: data?.principalPlaceBuildingNoFromGST,
          pincode: data?.principalPlacePincode,
          PAN: extractPANFromGST(gst),
        });

        if (
          clientName?.toLowerCase() !== data?.tradeNameOfBusiness?.toLowerCase()
        ) {
          setModalVisible(true);
        }
      } else {
        clearGSTFields();
      }
    } catch (error) {
      console.error("Error verifying GST:", error);
      clearGSTFields();
    }
  };

  const clearGSTFields = () => {
    setCheckStatus(false);
    form.setFieldsValue({
      organizationNamee: "",
      street: "",
      area: "",
      pincode: "",
      PAN: "",
      AADHAR: "",
      orgFormName: "",
    });
  };

  const updateClientName = () => {
    let orgName = form.getFieldValue("organizationNamee");
    form.setFieldValue(orgFormName, orgName);
    setModalVisible(false);
  };

  const validateWrapper = (event) => {
    if (checkNumbervalue(event) || checkSpace(event)) {
      event.preventDefault();
    }
  };
  return (
    <>
      <Col
        xs={rgColSpan || 24}
        sm={rgColSpan || 24}
        md={rgColSpan || 12}
        lg={rgColSpan || 12}
        xl={rgColSpan || 12}
        hidden={hideGst}
      >
        <Form.Item
          name="gstRegistred"
          label={"Is GST registred"}
          rules={[
            {
              required: hideGst || !required ? false : true,
              message: "Please select ",
            },
          ]}
        >
          <Radio.Group
            onChange={(e) => handleIsGSTRegistered(e)}
            className="calculater-container-div-radio"
            disabled={getData?.status?.toLowerCase() === "approved" || disable}
            // disabled={getData?.organizationDetails?.gst !== null && true}
          >
            <Radio value={true} className="radioButton">
              Yes
            </Radio>
            <Radio value={false} className="radioButton">
              No
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>
      {isGSTRegister ? (
        <Col xs={20} sm={20} md={12} lg={12} xl={12} hidden={hideGst}>
          <Form.Item
            name="GST"
            label="GSTIN"
            rules={[
              {
                message: "Please enter GSTIN",
                required: hideGst || !required ? false : true,
              },
              {
                pattern:
                  /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/g,
                message: "Invalid GSTIN",
              },
            ]}
            className="accpickupPincodeParent"
          >
            <Input
              className="accpickupPincode"
              placeholder="Enter GSTIN"
              disabled={
                getData?.status?.toLowerCase() === "approved" || disable
              }
              suffix={checkStatus ? <Reason /> : ""}
              maxLength={15}
              onChange={checkGST}
              // disabled={getData ? true : false}
              onKeyPress={(e) => {
                if (/[^A-Za-z0-9]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              //style={{ textTransform: "uppercase" }}
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            />
          </Form.Item>
        </Col>
      ) : (
        <Col xs={20} sm={20} md={12} lg={12} xl={12} hidden={hideAadhaar}>
          <Form.Item
            label="Aadhar number"
            name="AADHAR"
            rules={[
              {
                required: hideAadhaar && required ? false : true,
                message: "Please enter Aadhaar number",
              },
              {
                pattern: /^[2-9]{1}[0-9]{11}$/,
                message: "Aadhaar number must be 12 digits and start with 2-9",
              },
            ]}
            onKeyPress={validateWrapper}
          >
            <Input
              placeholder="Enter Aadhaar number"
              maxLength={12}
              disabled={
                getData?.status?.toLowerCase() === "approved" || disable
              }
            />
          </Form.Item>
        </Col>
      )}
      <Col
        xs={rgColSpan || 24}
        sm={rgColSpan || 24}
        md={rgColSpan || 12}
        lg={rgColSpan || 12}
        xl={rgColSpan || 12}
      >
        <Form.Item
          name={orgFormName}
          label={`${orgName} Name`}
          rules={[
            {
              message: `Please enter ${orgName} name`,
              required: hideGst && required ? false : true,
            },
            () => ({
              validator(rule, value = "") {
                if (value.substring(1, 0) === " ") {
                  return Promise.reject("Invalid client name ");
                } else {
                  return Promise.resolve();
                }
              },
            }),
          ]}
          onKeyPress={(event) => {
            if (checkAlphabets(event)) {
              event.preventDefault();
            }
          }}
        >
          <Input
            // style={{ textTransform: "capitalize" }}
            placeholder={`Enter ${orgName} name`}
            maxLength={40}
            onKeyPress={(event) => {
              if (checkAlphabets(event)) {
                event.preventDefault();
              }
            }}
            // disabled={getData ? true : false}
            onInput={(e) => (e.target.value = capitalize(e.target.value))}
            disabled={getData?.status?.toLowerCase() === "approved" || disable}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12} hidden={hidePan}>
        <Form.Item
          name="PAN"
          label={
            <span className="calculater-container-pikpin">PAN number</span>
          }
          onKeyPress={(event) => {
            if (checkSpecialCharacter(event) || checkSpace(event)) {
              event.preventDefault();
            }
          }}
          // rules={[
          //   {
          //     required: false,
          //     pattern: new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/g),
          //     message: "Enter a valid PAN number",
          //     validateTrigger: "onSubmit",
          //   },
          // ]}
        >
          <Input
            placeholder="Enter PAN number"
            // disabled={getData?.organizationDetails?.pan !== null && true}
            type="text"
            maxLength={10}
            onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            disabled={getData?.status?.toLowerCase() === "approved" || disable}
          />
        </Form.Item>
      </Col>
      <Col md={12} lg={12} xl={12} sm={24} xs={24} hidden={hideTan}>
        <Form.Item
          label="TAN Number"
          name="TAN"
          // rules={[
          //   {
          //     required: false,
          //     pattern: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
          //     message:
          //       "TAN must be in format AAAA99999A (4 letters, 5 digits, 1 letter)",
          //   },
          // ]}
        >
          <Input
            placeholder="Enter TAN Number"
            maxLength={10}
            // onChange={(e) => {
            //   e.target.value = e.target.value.toUpperCase();
            // }}
            disabled={getData?.status?.toLowerCase() === "approved" || disable}
            style={{ textTransform: "uppercase" }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <AutoCompleteAddress
          required={required}
          form={form}
          returnAddress={false}
          alertData={null}
          fieldName="street"
          label="Enter street address"
          rules={[
            {
              required: true,
              message: "Enter address",
            },
          ]}
          disabled={getData?.status?.toLowerCase() === "approved" || disable}
        />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item name="area" label="Address line 2">
          <Input
            placeholder="Enter address line 2"
            disabled={getData?.status?.toLowerCase() === "approved" || disable}
            // disabled={getData ? true : false}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <PinCodeValidator
          formName={"pincode"}
          value={
            gstPin ||
            getData?.addresses?.find((e) => e?.type === "DEFAULT")?.pincode
          }
          disabled={getData?.status?.toLowerCase() === "approved" || disable}
          ///required={required}
        />
      </Col>

      <Modal
        open={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={380}
        destroyOnClose
        closeIcon={<img src={cross_button} />}

        // maskClosable={false}
      >
        <Row className="global-form-row center" gutter={37}>
          <div style={{ width: "380px", padding: "2rem" }}>
            <div className="mb-1">
              {`Do you want to update ${orgName} name as per GST Validated name?`}
            </div>
            <div className="center">
              <Button
                className="btn-style"
                onClick={() => setModalVisible(false)}
              >
                NO
              </Button>
              <Button
                type="primary ml-1"
                className="save-btn"
                onClick={updateClientName}
              >
                YES
              </Button>
            </div>
          </div>
        </Row>
      </Modal>
    </>
  );
};

export default CreateKYC;
